import { render, staticRenderFns } from "./ComissaoBuscaTabela.vue?vue&type=template&id=5a93f0b4"
import script from "./ComissaoBuscaTabela.vue?vue&type=script&lang=js"
export * from "./ComissaoBuscaTabela.vue?vue&type=script&lang=js"
import style0 from "./ComissaoBuscaTabela.vue?vue&type=style&index=0&id=5a93f0b4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports